import React from 'react'
import CSS from './styles.module.css'

// Animate on Scroll
import AOS from 'aos'
import 'aos/dist/aos.css'
import { useEffect } from 'react'

const ActionBoxCard = ({
  icon,
  heading,
  content,
  tag,
  className,
}) => {
  useEffect(() => {
    AOS.init({ duration: 1200, delay: 100 })
  }, [])

  return (
    <div className={`${CSS.ActionBox} ${className}`}>
      <li className="material-symbols-round icon">{icon}</li>
      <h3>
        {heading}
        {tag && <span>{tag}</span>}
      </h3>
      {content}
    </div>
  )
}

export default ActionBoxCard
